export default __webpack_public_path__ + "static/media/program_list_img03.62d01135.jpg";